import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

class articleList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "articleList"}
                {...props}
                columns={{
                    "id": {header: "Kód", width: 1, filterable, sortable},
                    "headline": {header: "Cím", width: 3, filterable, sortable},
                    "author.name": {header: "Szerző", width: 1, filterable, sortable},
                    "publisher.name": {header: "Közzétevő", width: 1, sortable},
                    "publishdate": {header: "Közzétéve", width: 1, sortable},
                    "startdate": {header: "Kezdet", width: 1, sortable},
                    "expiry": {header: "Lejár", width: 1, sortable},
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default articleList;
